import { createContext } from 'react';

export type SnackbarInputType = Error | string;
export enum SnackbarMessageType {
  INFO,
  SUCCESS,
  WARN,
  ERROR,
}

export interface Snackbar {
  open: (input: SnackbarInputType, type?: SnackbarMessageType) => void;
  info: (input: SnackbarInputType) => void;
  success: (input: SnackbarInputType) => void;
  warn: (input: SnackbarInputType) => void;
  error: (input: SnackbarInputType) => void;
  close: () => void;
  isOpen: boolean;
  message: string;
  type: SnackbarMessageType;
}

export const SnackbarContext = createContext<Snackbar>({
  isOpen: false,
  message: '',
  type: SnackbarMessageType.INFO,

  close() {},
  open() {},
  info() {},
  success() {},
  error() {},
  warn() {},
});
